function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//@ts-nocheck

/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import React from 'react';
import { StyleSheet, View } from 'react-native';
import { TabBar } from "./tabBar.component";
import { ViewPager } from "../viewPager/viewPager.component";

class TabViewChildElement {
  constructor() {
    _defineProperty(this, "tab", void 0);

    _defineProperty(this, "content", void 0);
  }

}

class TabViewChildren {
  constructor() {
    _defineProperty(this, "tabs", []);

    _defineProperty(this, "contents", []);
  }

}

/**
 * A view with tabs and swipeable contents.
 *
 * @extends React.Component
 **
 * @property {ReactElement<TabProps> | ReactElement<TabProps>[]} children - Tabs to be rendered within the view.
 *
 * @property {number} selectedIndex - Index of currently selected tab.
 *
 * @property {(number) => void} onSelect - Called when tab is pressed or its content becomes visible.
 *
 * @property {(number) => boolean} shouldLoadComponent - A function to determine
 * whether content for particular tab should be rendered.
 * Useful when providing "lazy" loading behavior.
 *
 * @property {(number) => void} onOffsetChange - Called when scroll offset changes.
 *
 * @property {StyleProp<ViewStyle>} tabBarStyle - Style of TabBar component.
 *
 * @property {StyleProp<ViewStyle>} indicatorStyle - Style of selected tab indicator.
 *
 * @property {ViewProps} ...ViewProps - Any props applied to View component.
 *
 * @overview-example TabViewSimpleUsage
 * TabView is an alternative way to build tabbed screens, without a need to configure routing.
 *
 * @overview-example TabViewLazyLoading
 * Tab contents may be loaded lazily, by configuring `shouldLoadComponent` property.
 */
export class TabView extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "viewPagerRef", /*#__PURE__*/React.createRef());

    _defineProperty(this, "tabBarRef", /*#__PURE__*/React.createRef());

    _defineProperty(this, "onBarSelect", index => {
      this.props.onSelect && this.props.onSelect(index);
    });

    _defineProperty(this, "onPagerOffsetChange", offset => {});

    _defineProperty(this, "onPagerSelect", index => {
      this.props.onSelect && this.props.onSelect(index);
    });

    _defineProperty(this, "renderComponentChild", (element, index) => {
      return {
        tab: /*#__PURE__*/React.cloneElement(element, {
          key: index
        }),
        content: element.props.children
      };
    });

    _defineProperty(this, "renderComponentChildren", source => {
      const children = React.Children.toArray(source);
      return children.reduce((acc, element, index) => {
        const {
          tab,
          content
        } = this.renderComponentChild(element, index);
        return {
          tabs: [...acc.tabs, tab],
          contents: [...acc.contents, content]
        };
      }, new TabViewChildren());
    });
  }

  render() {
    const _this$props = this.props,
          {
      style,
      selectedIndex,
      children,
      tabBarStyle,
      indicatorStyle
    } = _this$props,
          viewProps = _objectWithoutProperties(_this$props, ["style", "selectedIndex", "children", "tabBarStyle", "indicatorStyle"]);

    const {
      tabs,
      contents
    } = this.renderComponentChildren(children);
    return /*#__PURE__*/React.createElement(View, _extends({}, viewProps, {
      style: [styles.container, style]
    }), /*#__PURE__*/React.createElement(TabBar, {
      style: tabBarStyle,
      ref: this.tabBarRef,
      selectedIndex: selectedIndex,
      indicatorStyle: indicatorStyle,
      onSelect: this.onBarSelect
    }, tabs), /*#__PURE__*/React.createElement(ViewPager, _extends({
      ref: this.viewPagerRef
    }, viewProps, {
      style: [styles.container, style],
      selectedIndex: selectedIndex,
      shouldLoadComponent: this.props.shouldLoadComponent,
      onOffsetChange: this.onPagerOffsetChange,
      onSelect: this.onPagerSelect
    }), contents));
  }

}

_defineProperty(TabView, "defaultProps", {
  selectedIndex: 0
});

const styles = StyleSheet.create({
  container: {
    overflow: 'hidden'
  }
});